import React from "react";
import ReactEcharts from "echarts-for-react";
import { useMediaQuery } from "@material-ui/core";

const FarmerProgressBarChart = ({ farmerDataCl = 0, chartName, left }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const symbols = [
    "path://M902 1886 c-2 -67 -1 -70 38 -112 47 -51 49 -78 15 -142 -1 -1 -23 7 -49 18 -31 14 -55 34 -71 61 -29 45 -40 51 -23 12 17 -41 58 -82 94 -95 26 -9 32 -17 32 -39 -1 -27 -2 -27 -32 -14 -17 7 -49 18 -71 24 -22 6 -50 13 -63 16 -12 4 -36 18 -52 32 -17 13 -28 18 -25 10 13 -31 124 -87 175 -87 9 0 25 -7 36 -16 18 -14 18 -15 -6 -8 -26 8 -221 7 -229 -1 -2 -3 36 -5 86 -5 84 0 192 -21 194 -38 0 -4 2 -23 3 -42 6 -66 27 -205 41 -268 18 -76 18 -95 4 -146 -15 -56 -59 -96 -102 -96 -38 0 -36 -3 -52 95 -8 49 -39 97 -80 122 -23 14 -59 19 -160 24 -71 4 -140 10 -152 14 -29 9 -31 -15 -4 -53 10 -15 31 -51 45 -80 36 -70 101 -135 160 -157 44 -17 51 -17 113 -2 46 11 72 13 91 6 30 -11 76 -3 111 20 24 15 24 15 17 -14 -14 -55 -61 -139 -86 -153 -19 -10 -50 -11 -120 -6 -52 3 -113 6 -135 7 -48 0 -127 -38 -173 -84 -38 -37 -92 -137 -92 -170 0 -21 2 -22 88 -16 227 16 389 110 493 286 l37 62 4 -48 c3 -36 -5 -72 -30 -143 -30 -88 -33 -103 -30 -196 3 -96 6 -106 43 -180 64 -127 232 -281 267 -246 17 17 24 262 9 333 -18 87 -56 156 -126 228 -35 37 -71 84 -80 105 -16 38 -34 246 -22 246 4 0 18 -22 31 -48 53 -105 149 -157 291 -157 74 0 87 3 173 44 59 29 92 50 92 60 0 9 -33 35 -78 61 -73 43 -81 45 -152 45 -65 0 -87 -6 -162 -39 -53 -22 -95 -35 -107 -31 -33 10 -63 99 -69 203 l-5 94 47 -33 c58 -42 150 -51 205 -22 46 24 48 37 9 64 -40 29 -90 30 -146 5 -35 -16 -47 -17 -68 -8 -42 20 -56 71 -52 193 3 97 5 111 26 131 20 20 33 23 107 23 68 0 88 3 102 18 17 17 17 18 -10 8 -30 -12 -107 -15 -107 -5 0 3 11 15 24 25 30 24 56 79 55 116 -1 20 -3 22 -6 8 -9 -42 -34 -84 -64 -109 -30 -26 -75 -43 -85 -33 -3 3 -17 -6 -32 -20 -24 -22 -27 -23 -31 -7 -2 11 12 31 37 53 22 20 44 47 47 61 4 14 11 30 16 36 5 7 3 11 -5 11 -8 0 -18 -12 -21 -26 -7 -27 -42 -71 -57 -71 -13 0 -8 83 7 110 8 14 14 34 15 45 0 11 -11 -4 -25 -33 -15 -33 -25 -72 -25 -100 l0 -46 -21 20 c-20 20 -20 23 -5 52 25 49 20 76 -24 127 -42 49 -48 63 -53 135 -3 32 -4 25 -5 -24z m78 -305 c10 -20 4 -51 -10 -51 -11 0 -20 39 -13 56 7 18 10 18 23 -5z m301 -401 c10 -6 19 -15 19 -19 0 -14 -82 -30 -115 -23 l-30 6 25 7 25 7 -25 2 c-25 2 -25 2 5 15 36 17 70 19 96 5z m-541 -35 c43 -22 70 -68 77 -127 l6 -53 -39 36 c-46 43 -66 54 -116 63 -51 9 -48 1 7 -17 42 -15 125 -72 125 -87 0 -4 -21 -11 -46 -17 -62 -14 -106 -1 -159 48 -35 32 -105 141 -105 163 0 3 50 6 110 6 79 0 119 -4 140 -15z m773 -255 c31 -19 57 -37 57 -41 0 -3 -33 -21 -72 -39 -63 -29 -82 -34 -148 -33 -41 1 -92 7 -113 15 l-38 13 83 13 c45 8 89 18 98 23 11 8 6 9 -17 5 -80 -13 -160 -17 -183 -8 l-25 9 35 18 c140 73 230 80 323 25z m-758 -160 c38 -6 71 -13 73 -15 6 -5 -100 -42 -158 -54 -30 -6 -62 -16 -70 -22 -12 -9 -12 -10 4 -5 10 4 51 11 89 16 44 7 91 22 126 41 l56 30 -40 -41 c-73 -76 -267 -150 -390 -150 l-35 0 29 59 c31 59 69 99 125 128 37 20 86 32 106 27 8 -2 46 -8 85 -14z m305 -325 c14 -44 71 -157 76 -152 2 2 -12 41 -30 88 -23 54 -40 122 -50 193 -9 60 -15 110 -13 112 1 2 35 -33 74 -76 92 -102 114 -156 121 -302 2 -58 1 -127 -2 -152 l-7 -46 -29 15 c-73 38 -188 186 -215 279 -22 73 -19 173 7 253 l23 68 16 -120 c9 -67 22 -139 29 -160z",
  ];
  const bodyMax = 100;

  // const labelSetting = {
  //   show: true,
  //   position: "inside", // or "right" if you want to place on the right
  //   offset: [30, 90],     // [x, y] → pushes label downward
  //   formatter: function (param) {
  //     return ((param.value / bodyMax) * 100).toFixed(0) + "%";
  //   },
  //   fontSize: 16,
  //   fontFamily: "Arial",
  //   color: "#000", // label text color
  // };

  // const option = {
  //   tooltip: {
  //     formatter: function (params) {
  //       const { value } = params?.params[0];
  //       return `Crop Health: ${((value / bodyMax) * 100).toFixed(0)}%`;
  //     },
  //   },
  //   legend: {
  //     data: ["Health Score"],
  //     selectedMode: "single",
  //     bottom: -10,
  //     left: "30%",
  //     itemWidth: 10,
  //     itemHeight: 10,
  //     textStyle: {
  //       fontSize: 14,
  //     },
  //     padding: [0, 0, 30, 0],
  //   },
  //   xAxis: {
  //     data: ["a"],
  //     axisTick: { show: false },
  //     axisLine: { show: false },
  //     axisLabel: { show: false },
  //   },
  //   yAxis: { show: false },
  //   grid: {
  //     top: 20,
  //     height: "230px",
  //     width: 350,
  //   },
  //   series: [
  //     {
  //       name: "Health Score",
  //       type: "pictorialBar",
  //       symbol: symbols[0],
  //       symbolClip: true,
  //       symbolBoundingData: bodyMax,
  //       label: labelSetting,
  //       symbolOffset: [0, 0],
  //       itemStyle: {
  //         color: "red",
  //       },
  //       data: [
  //         {
  //           value: farmerDataCl * 100,
  //         },
  //       ],
  //       z: 50,
  //     },
  //     {
  //       name: "full",
  //       type: "pictorialBar",
  //       symbol: symbols[0],
  //       symbolBoundingData: bodyMax,
  //       animationDuration: 0,
  //       itemStyle: {
  //         color: "#ccc",
  //       },
  //       data: [
  //         {
  //           value: 100,
  //         },
  //       ],
  //     },
  //   ],
  // };
  const currentValue = ((farmerDataCl * 100) / bodyMax).toFixed(2) + "%";

  const labelSetting = {
    show: false,
    position: "inside",
    offset: [0, 30],
    formatter: function(param) {
      return ((param.value / bodyMax) * 100).toFixed(2) + "%";
    },
    fontSize: 16,
    fontFamily: "Arial",
    color: "#000",
  };

  const option = {
    tooltip: {
      formatter: function(params) {
        const { value } = params?.params[0];
        return `Crop Health: ${((value / bodyMax) * 100).toFixed(2)}%`;
      },
    },
    legend: {
      data: ["Health Score"],
      selectedMode: "single",
      bottom: -20,
      left: isMobile ? "10%" : "20%",
      itemWidth: 10,
      itemHeight: 10,
      textStyle: {
        fontSize: 14,
        fontWeight: 700,
        color: "rgba(95, 94, 94, 0.92941176",
        offsetY: 35,
      },
      padding: [0, 0, 30, 0],
      // formatter: function(name) {
      //   return `${name} - ${farmerDataCl * 100}.toFixed(2)%`;

      // },
      formatter: function (name) {
  const val = farmerDataCl * 100;

  // If value is an integer (no decimal)
  if (Number.isInteger(val)) {
    return `${name} - ${val}%`;
  }

  // If decimal exists → show 2 digits
  return `${name} - ${val.toFixed(2)}%`;
}

    },
    xAxis: {
      data: ["a"],
      axisTick: { show: false },
      axisLine: { show: false },
      axisLabel: { show: false },
    },
    yAxis: { show: false },
    grid: {
      top: 20,
      height: "230px",
      width: 250,
    },
    series: [
      {
        name: "Health Score",
        type: "pictorialBar",
        symbol: symbols[0],
        symbolClip: true,
        symbolBoundingData: bodyMax,
        label: labelSetting,
        symbolOffset: [0, 0],
        itemStyle: {
          color: "rgb(91, 225, 44,0.6)",
        },
        data: [
          {
            value: farmerDataCl * 100,
          },
        ],
        z: 10,
      },
      {
        name: "full",
        type: "pictorialBar",
        symbol: symbols[0],
        symbolBoundingData: bodyMax,
        animationDuration: 0,
        itemStyle: {
          color: "#ccc",
        },
        data: [
          {
            value: 100,
          },
        ],
      },
    ],
  };

  return (
    <div className="">
      <ReactEcharts
        option={option}
        style={{ left: left, height: "308px" }}
        className="text-center d-flex justify-content-center align-items-center leaf"
      />
    </div>
  );
};

export default FarmerProgressBarChart;

// import React, { useEffect, useState } from "react";

// const stages = [
//   {
//     min: 0,
//     max: 10,
//     label: "Very Poor Health",
//     svg: (
//       <svg
//         width="100"
//         height="150"
//         viewBox="0 0 64 96"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <rect width="64" height="96" fill="#704214" />
//         <ellipse cx="32" cy="75" rx="15" ry="10" fill="#5C4033" />
//         <line
//           x1="32"
//           y1="70"
//           x2="32"
//           y2="55"
//           stroke="#3B6E22"
//           strokeWidth="3"
//           strokeLinecap="round"
//         />
//         <path
//           d="M32 55 Q30 45 34 40"
//           stroke="#4CAF50"
//           strokeWidth="3"
//           fill="none"
//           strokeLinecap="round"
//         />
//         <circle cx="34" cy="40" r="3" fill="#81C784" />
//       </svg>
//     ),
//   },
//   {
//     min: 11,
//     max: 40,
//     label: "Poor Health",
//     svg: (
//       <svg
//         width="100"
//         height="150"
//         viewBox="0 0 64 96"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <rect width="64" height="96" fill="#705030" />
//         <ellipse cx="32" cy="65" rx="20" ry="12" fill="#4C7C35" />
//         <line
//           x1="32"
//           y1="65"
//           x2="32"
//           y2="30"
//           stroke="#357a38"
//           strokeWidth="4"
//           strokeLinecap="round"
//         />
//         <circle cx="28" cy="28" r="6" fill="#6ABF69" />
//         <circle cx="36" cy="28" r="6" fill="#6ABF69" />
//       </svg>
//     ),
//   },
//   {
//     min: 41,
//     max: 75,
//     label: "Good Health",
//     svg: (
//       <svg
//         width="100"
//         height="150"
//         viewBox="0 0 64 96"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         {/* Growing plant */}
//         <rect width="64" height="96" fill="#6B4F20" />
//         <line
//           x1="32"
//           y1="80"
//           x2="32"
//           y2="35"
//           stroke="#2C662D"
//           strokeWidth="6"
//           strokeLinecap="round"
//         />
//         <ellipse cx="32" cy="30" rx="15" ry="8" fill="#3D8A3D" />
//         <ellipse cx="20" cy="40" rx="10" ry="5" fill="#4AA54A" />
//         <ellipse cx="44" cy="40" rx="10" ry="5" fill="#4AA54A" />
//         <ellipse cx="25" cy="55" rx="7" ry="3" fill="#3B7539" />
//         <ellipse cx="39" cy="55" rx="7" ry="3" fill="#3B7539" />
//       </svg>
//     ),
//   },
//   {
//     min: 76,
//     max: 100,
//     label: "Excellent Health",
//     svg: (
//       <svg
//         width="100"
//         height="150"
//         viewBox="0 0 64 96"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         {/* Full grown plant */}
//         <rect width="64" height="96" fill="#574117" />
//         <line
//           x1="32"
//           y1="90"
//           x2="32"
//           y2="20"
//           stroke="#1B4D1B"
//           strokeWidth="8"
//           strokeLinecap="round"
//         />
//         <circle cx="32" cy="15" r="15" fill="#2E7D32" />
//         <circle cx="20" cy="40" r="10" fill="#1B5E20" />
//         <circle cx="44" cy="40" r="10" fill="#1B5E20" />
//         <circle cx="25" cy="60" r="7" fill="#388E3C" />
//         <circle cx="39" cy="60" r="7" fill="#388E3C" />
//       </svg>
//     ),
//   },
// ];

// const FarmerProgressBarChart = ({ healthScore }) => {
//   const score = Math.min(Math.max(.72 * 100, 0), 100);

//   const [stage, setStage] = useState(() => {
//     return stages.find((s) => score >= s.min && score <= s.max) || stages[0];
//   });

//   useEffect(() => {
//     const newStage = stages.find((s) => score >= s.min && score <= s.max) || stages[0];
//     setStage(newStage);
//   }, [score]);

//   return (
//     <div
//       style={{
//         textAlign: "center",
//         width: 140,
//         margin: "auto",
//         padding: 20,
//         background: "#f3f6f2",
//         borderRadius: 20,
//         boxShadow: "0 0 15px rgba(50, 115, 60, 0.2)",
//         userSelect: "none",
//       }}
//     >
//       <div
//         style={{
//           marginBottom: 12,
//           fontWeight: "bold",
//           fontSize: 18,
//           color: "#2e7d32",
//           fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//         }}
//       >
//         {stage.label}
//       </div>
//       <div
//         key={stage.label} // important to reset animation on stage change
//         style={{
//           animation: "growFadeIn 1s ease forwards",
//           display: "inline-block",
//         }}
//       >
//         {stage.svg}
//       </div>
//       <div
//         style={{
//           marginTop: 14,
//           fontSize: 20,
//           fontWeight: "bold",
//           color: "#33691e",
//           fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//         }}
//       >
//         {score.toFixed(0)}%
//       </div>

//       <style>
//         {`
//           @keyframes growFadeIn {
//             0% {
//               opacity: 0;
//               transform: scale(0.7);
//             }
//             100% {
//               opacity: 1;
//               transform: scale(1);
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default FarmerProgressBarChart;

// import React from "react";
// import ReactEcharts from "echarts-for-react";

// const FarmerProgressBarChart = ({ farmerDataCl, chartName }) => {
//   const symbols = [
//     "path://M902 1886 c-2 -67 -1 -70 38 -112 47 -51 49 -78 15 -142 -1 -1 -23 7 -49 18 -31 14 -55 34 -71 61 -29 45 -40 51 -23 12 17 -41 58 -82 94 -95 26 -9 32 -17 32 -39 -1 -27 -2 -27 -32 -14 -17 7 -49 18 -71 24 -22 6 -50 13 -63 16 -12 4 -36 18 -52 32 -17 13 -28 18 -25 10 13 -31 124 -87 175 -87 9 0 25 -7 36 -16 18 -14 18 -15 -6 -8 -26 8 -221 7 -229 -1 -2 -3 36 -5 86 -5 84 0 192 -21 194 -38 0 -4 2 -23 3 -42 6 -66 27 -205 41 -268 18 -76 18 -95 4 -146 -15 -56 -59 -96 -102 -96 -38 0 -36 -3 -52 95 -8 49 -39 97 -80 122 -23 14 -59 19 -160 24 -71 4 -140 10 -152 14 -29 9 -31 -15 -4 -53 10 -15 31 -51 45 -80 36 -70 101 -135 160 -157 44 -17 51 -17 113 -2 46 11 72 13 91 6 30 -11 76 -3 111 20 24 15 24 15 17 -14 -14 -55 -61 -139 -86 -153 -19 -10 -50 -11 -120 -6 -52 3 -113 6 -135 7 -48 0 -127 -38 -173 -84 -38 -37 -92 -137 -92 -170 0 -21 2 -22 88 -16 227 16 389 110 493 286 l37 62 4 -48 c3 -36 -5 -72 -30 -143 -30 -88 -33 -103 -30 -196 3 -96 6 -106 43 -180 64 -127 232 -281 267 -246 17 17 24 262 9 333 -18 87 -56 156 -126 228 -35 37 -71 84 -80 105 -16 38 -34 246 -22 246 4 0 18 -22 31 -48 53 -105 149 -157 291 -157 74 0 87 3 173 44 59 29 92 50 92 60 0 9 -33 35 -78 61 -73 43 -81 45 -152 45 -65 0 -87 -6 -162 -39 -53 -22 -95 -35 -107 -31 -33 10 -63 99 -69 203 l-5 94 47 -33 c58 -42 150 -51 205 -22 46 24 48 37 9 64 -40 29 -90 30 -146 5 -35 -16 -47 -17 -68 -8 -42 20 -56 71 -52 193 3 97 5 111 26 131 20 20 33 23 107 23 68 0 88 3 102 18 17 17 17 18 -10 8 -30 -12 -107 -15 -107 -5 0 3 11 15 24 25 30 24 56 79 55 116 -1 20 -3 22 -6 8 -9 -42 -34 -84 -64 -109 -30 -26 -75 -43 -85 -33 -3 3 -17 -6 -32 -20 -24 -22 -27 -23 -31 -7 -2 11 12 31 37 53 22 20 44 47 47 61 4 14 11 30 16 36 5 7 3 11 -5 11 -8 0 -18 -12 -21 -26 -7 -27 -42 -71 -57 -71 -13 0 -8 83 7 110 8 14 14 34 15 45 0 11 -11 -4 -25 -33 -15 -33 -25 -72 -25 -100 l0 -46 -21 20 c-20 20 -20 23 -5 52 25 49 20 76 -24 127 -42 49 -48 63 -53 135 -3 32 -4 25 -5 -24z m78 -305 c10 -20 4 -51 -10 -51 -11 0 -20 39 -13 56 7 18 10 18 23 -5z m301 -401 c10 -6 19 -15 19 -19 0 -14 -82 -30 -115 -23 l-30 6 25 7 25 7 -25 2 c-25 2 -25 2 5 15 36 17 70 19 96 5z m-541 -35 c43 -22 70 -68 77 -127 l6 -53 -39 36 c-46 43 -66 54 -116 63 -51 9 -48 1 7 -17 42 -15 125 -72 125 -87 0 -4 -21 -11 -46 -17 -62 -14 -106 -1 -159 48 -35 32 -105 141 -105 163 0 3 50 6 110 6 79 0 119 -4 140 -15z m773 -255 c31 -19 57 -37 57 -41 0 -3 -33 -21 -72 -39 -63 -29 -82 -34 -148 -33 -41 1 -92 7 -113 15 l-38 13 83 13 c45 8 89 18 98 23 11 8 6 9 -17 5 -80 -13 -160 -17 -183 -8 l-25 9 35 18 c140 73 230 80 323 25z m-758 -160 c38 -6 71 -13 73 -15 6 -5 -100 -42 -158 -54 -30 -6 -62 -16 -70 -22 -12 -9 -12 -10 4 -5 10 4 51 11 89 16 44 7 91 22 126 41 l56 30 -40 -41 c-73 -76 -267 -150 -390 -150 l-35 0 29 59 c31 59 69 99 125 128 37 20 86 32 106 27 8 -2 46 -8 85 -14z m305 -325 c14 -44 71 -157 76 -152 2 2 -12 41 -30 88 -23 54 -40 122 -50 193 -9 60 -15 110 -13 112 1 2 35 -33 74 -76 92 -102 114 -156 121 -302 2 -58 1 -127 -2 -152 l-7 -46 -29 15 c-73 38 -188 186 -215 279 -22 73 -19 173 7 253 l23 68 16 -120 c9 -67 22 -139 29 -160z",
//   ];
//   const bodyMax = 100;
//   const labelSetting = {
//     show: true,
//     position: "right",
//     offset: [10, 90],
//     bottom: 0,
//     formatter: function(param) {
//       return ((param.value / bodyMax) * 100).toFixed(0) + "%";
//     },
//     fontSize: 16,
//     fontFamily: "Arial",
//   };
//   const markLineSetting = {
//     symbol: "none",
//   };

//   const option = {
//     tooltip: {
//       formatter: function(params) {
//         const { value } = params?.params[0];
//         return `Crop Health: ${((value / bodyMax) * 100).toFixed(0)}%`;
//       },
//     },

//     legend: {
//       data: ["Health Score"],
//       selectedMode: "single",
//       bottom: 0,
//       left: 40,
//       itemWidth: 10,
//       itemHeight: 10,
//       textStyle: {
//         fontSize: 14,
//       },
//       padding: [0, 0, 30, 0],
//     },

//     xAxis: {
//       data: ["a", "b", "c", "d", "e"],
//       axisTick: { show: false },
//       axisLine: { show: false },
//       axisLabel: { show: false },
//     },
//     yAxis: {
//       show: false,
//     },
//     grid: {
//       top: "center",
//       height: "180px",
//       width: 800,
//     },
//     markLine: {
//       z: -100,
//     },
//     series: [
//       {
//         name: "Health Score",
//         type: "pictorialBar",
//         symbolClip: true,
//         symbolBoundingData: bodyMax,
//         label: labelSetting,
//         itemStyle: {
//           color: "rgb(91, 225, 44,0.6)",
//           align: "center",
//         },
//         data: [
//           {
//             value: farmerDataCl * 100,
//             symbol: symbols[0],
//           },
//         ],
//         markLine: markLineSetting,
//         z: 10,
//       },
//       {
//         name: "full",
//         type: "pictorialBar",
//         symbolBoundingData: bodyMax,
//         animationDuration: 0,
//         itemStyle: {
//           color: "#ccc",
//         },
//         data: [
//           {
//             value: 100,
//             symbol: symbols[0],
//           },
//         ],
//       },
//     ],
//   };
//   return (
//     <div className="">
//       <ReactEcharts
//         option={option}
//         style={{ height: "250px", top: "-10px", left: "30px" }}
//         className="text-center  d-flex justify-content-center align-items-center leaf"
//       />
//     </div>
//   );
// };

// export default FarmerProgressBarChart;
